import { render } from "./loading-button.vue?vue&type=template&id=35a52726&scoped=true"
import script from "./loading-button.vue?vue&type=script&lang=js"
export * from "./loading-button.vue?vue&type=script&lang=js"

import "./loading-button.vue?vue&type=style&index=0&id=35a52726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a52726"]])

export default __exports__